import React, { useEffect, useState } from "react";
import './styles.css'
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserOperator, isLoggedInUserAdmin, isLoggedInUserBusiness, isNull, isValidEmail, screenCaptureAnalytics } from "../../../utils/Utils";
import { loginUserRequest, displaySideBarAct } from '../../../redux/user/user.action'
import { useDispatch, useSelector } from 'react-redux'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import NavBarComponent from "../../landing/nav-bar/navBar";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import PasswordInputFull from "../../../components/input/password-input-full/passwordInputFull";
import Modal from 'react-bootstrap/Modal';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { updateTransactionStatusRequest, updateTransactionStatusRequestStatus } from '../../../redux/subscription/subscription.action'
import { config } from "../../../config";

const BusinessLogin = props => {
    const [isLoading, setLoading] = useState(false)
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    let navigate = useNavigate();
    const { user, isLogin, loginErrorData } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const { updateTransactionStatusSuccess, updateTransactionStatusError, updateTransactionStatusReqStatus
    } = useSelector(state => state.subscription)
    const [showPaymentModal, setShowPaymentModal] = useState(false)
    const [showUpdateTransactionModal, setShowUpdateTransactionModal] = useState(false)

    useEffect(() => {
        dispatch({ type: APP_CONSTANTS.LOGOUT })
        sessionStorage.clear()
        if (config.environment === APP_CONSTANTS.ENVIRONMENT.PROD) {
            const data = {
                screen: 'BUSINESS_LOGIN_PAGE',
                screenClass: 'BUSINESS_LOGIN_PAGE'
            }
            screenCaptureAnalytics(data)
        }
    }, [])

    useEffect(() => {
        if (isLogin) {
            setLoading(false)
            displaySuccessToast('Login Successful')
            sessionStorage.setItem(APP_CONSTANTS.USER, JSON.stringify(user.data))
            sessionStorage.setItem(APP_CONSTANTS.USER_TOKEN, JSON.stringify(user.data.authToken))
            if (isLoggedInUserBusiness(user)) {
                if (user.data.userDetails.isPaymentPending === true && !isEmpty(user.data.userDetails.transaction)) {
                    setShowPaymentModal(true)
                } else if (user.data.userDetails.subscriptionEnded === true) {
                    navigate(ROUTES.subscriptionRenew, { replace: true })
                } else {
                    navigateToNextScreen()
                }
            } else if (isLoggedInUserAdmin(user)) {
                navigate(ROUTES.menu, { replace: true })
            }
        } else {
            if (loginErrorData) {
                setLoading(false)
                displayErrorToast(loginErrorData.message)
            }
        }
    }, [user, isLogin, loginErrorData])

    useEffect(() => {
        if (updateTransactionStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            navigateToNextScreen()
        } else if (updateTransactionStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            setShowUpdateTransactionModal(true)
        }
        if (updateTransactionStatusReqStatus?.length) {
            dispatch(updateTransactionStatusRequestStatus(''))
        }
    }, [updateTransactionStatusSuccess, updateTransactionStatusError, updateTransactionStatusReqStatus])

    const navigateToNextScreen = () => {
        if (user.data.userDetails.isProfileUpdated === false) {
            navigate(ROUTES.updateProfile, { replace: true })
        } else {
            navigate(ROUTES.menu, { replace: true })
        }
    }

    const handleLoginClick = () => {
        if (isEmpty(email)) {
            displayErrorToast('Email cannot be blank')
        } else if (!isValidEmail(email)) {
            displayErrorToast('Invalid email id')
        } else if (isEmpty(password)) {
            displayErrorToast('Password cannot be blank')
        } else {
            const data = {
                email: email,
                password: password
            }
            setLoading(true)
            dispatch(loginUserRequest(data))
        }
    }

    const handleCreateAccountClick = () => {
        navigate(ROUTES.businessCreateAccount)
    }

    const handleEmployeeAccessClick = () => {
        navigate(ROUTES.employeeLogin)
    }

    const handleForgotPassClick = () => {
        navigate(ROUTES.forgotPassword)
    }

    const handleUpdateTransactionStatus = () => {
        setLoading(true)
        const data = {
            transactionId: user.data.userDetails.transaction.transactionId,
            userId: user.data.userDetails.userId,
            transactionStatus: APP_CONSTANTS.TRANSACTION_STATUS.PAID
        }
        dispatch(updateTransactionStatusRequest(data))
        setShowUpdateTransactionModal(false)
    }

    const handlePaypalApprove = (data, actions) => {
        return actions.order.capture().then((details) => {
            console.log("Transaction completed:", details);
            console.log("Transaction completed:", details.status);
            if (details.status === 'COMPLETED') {
                setShowPaymentModal(false)
                handleUpdateTransactionStatus()
            }
        }).catch(err => {
            console.error("Transaction failed:", err);
            displayErrorToast('Transaction failed. Please try again.')
        });
    };

    const handlePaypalCancel = (data) => {
        displayErrorToast('You have cancelled the payment processing. Please process with payment to continue.')
    }

    const handlePaypalError = (error) => {
        displayErrorToast('Error occured. Please try again.')
        console.log('paypal error', error)
    }

    return (
        <>
            <NavBarComponent navigate={navigate}
                showHome={true}
                isWhiteBackground={true}
                showBusinessRegistration={true} />
            <div className='sign-in-parent-container'>
                <div className='sign-in-img-layout-container'>
                    <img src={require('../../../assets/sign-in-banner.jpg')} className='sign-up-img-container' />
                    <img src={require('../../../assets/sign-in-banner-tab.jpg')} className='sign-up-tab-img-container' />
                    {/* <div className="sign-up-brand-label">GOMOBITES</div> */}
                </div>
                <div className='sign-in-content-layout-container'>
                    <div className="sign-in-logo-container">
                        <img src={require('../../../assets/logo_togethra_icon.png')} alt='logo' className="img" />
                    </div>
                    <div className='sign-in-heading'>Login to <span className='sign-in-heading-label'>togethra</span></div>
                    <FormFieldLabel label='Login with your registered business credentials' className='sign-in-sub-text-label margin-bottom-10' />
                    <CommonInputFloatFull
                        id="email"
                        placeholder="Email Address"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        type="email" />
                    <PasswordInputFull
                        id="password"
                        placeholder="Password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        type="password" />
                    <div className='si-forgot-password-label' onClick={() => handleForgotPassClick()}>FORGOT PASSWORD</div>
                    <ButtonRow>
                        <CommonButton label='Login'
                            onClick={() => handleLoginClick()}
                        />
                        <CommonButton label='Employee Access'
                            onClick={() => handleEmployeeAccessClick()}
                            isInverted={true}
                        />
                    </ButtonRow>
                    <div className='sign-in-or-label'>OR</div>
                    <div className='sign-in-create-account-label'>Not a member? <span className='sign-in-create-account-label-italic' onClick={() => { handleCreateAccountClick() }}>Create Account</span></div>
                </div>
            </div>
            <Modal
                onHide={() => { setShowPaymentModal(false) }}
                show={showPaymentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static" keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Congratulations! 🎉
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="bca-success-modal-container">
                        <p className="bca-smc-label-one">You have successfully registered on <strong>Togethra</strong>.</p>
                        <p className="bca-smc-label-two">We’re excited to have you onboard. Start exploring today!</p>
                        <p className="bca-smc-label-three">To proceed, please select the option below to complete your payment.</p>
                        <PayPalScriptProvider options={{
                            intent: "capture",
                            clientId: config.PP_ID
                        }}>
                            <PayPalButtons
                                createOrder={(data, actions) => {
                                    return actions.order.create({
                                        intent: "CAPTURE",
                                        purchase_units: [{
                                            amount: {
                                                value: isEmpty(user) ? 0 : user.data.userDetails.transaction.amount,
                                                "currency_code": (!isEmpty(user) && !isEmpty(user.data.userDetails.transaction)) ? user.data.userDetails.transaction.currencyCode : 'USD'
                                            }
                                        }],
                                        application_context: {
                                            shipping_preference: "NO_SHIPPING",
                                            user_action: "PAY_NOW"
                                        },
                                        payer: {
                                            "name": {
                                                "given_name": !isEmpty(user) ? user.data.userDetails.firstName : "Firstname",
                                                "surname": !isEmpty(user) ? user.data.userDetails.lastName : "Lastname"
                                            },
                                            "email_address": !isEmpty(user) ? user.data.userDetails.email : "payer@example.com",
                                        }
                                    });
                                }}
                                onApprove={handlePaypalApprove}
                                onError={handlePaypalError}
                                onCancel={handlePaypalCancel}
                            />

                            {/* {success && <p style={{ color: "green" }}>Payment Successful!</p>}
                            {error && <p style={{ color: "red" }}>Error: {error}</p>} */}
                        </PayPalScriptProvider>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowUpdateTransactionModal(false) }}
                show={showUpdateTransactionModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static" keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Error
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="at-success-modal-container">
                        <div className="at-success-text">Something went wrong while processing payment confirmation. Please click try again to continue</div>
                        <div className="at-modal-btn-container">
                            <div className="at-modal-yes-btn" onClick={() => { handleUpdateTransactionStatus() }}>TRY AGAIN</div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default BusinessLogin